import { useApolloClient } from '@apollo/client'

export function useApolloClientContext() {
  const client = useApolloClient()
  return client
}
